import {getBootstrapData} from '@ui/bootstrap-data/bootstrap-data-store';
import {Track} from '@app/web-player/tracks/track';
import {MediaItem} from '@common/player/media-item';
import {PlayerState} from '@common/player/state/player-state';
import {apiClient} from '@common/http/query-client';
import { AppReviewManager } from '@common/core/capacitor/app-review-manager';
import { logEvent } from '@common/core/event-logger';

export function playerLog(state: () => PlayerState) {
    let time: number = getBootstrapData().settings.player?.log_time ?? 30;
    let volumeMin: number = getBootstrapData().settings.player?.log_volume_min ?? 0;
    let media: MediaItem<Track> | undefined;
    let timer: number = 0;
    let eventInterval: any;
    let logInterval: any;
    let interval_timer: number = 100;
    let mediaIsLogged: boolean = false;
    let playCount: number = parseInt(localStorage.getItem('kscolta.playCount') || '0') + 1;
    let playCountToRequestFirstReview: number = getBootstrapData().settings.player?.request_first_review ?? 10;
    let playCountToRequestOtherReview: number = getBootstrapData().settings.player?.request_other_review ?? 25;
    let loggedEvents: number[] = [];

    
    time = time*1000;   // convert s in ms

    const logEvents: number[] = [50, 90];

    const startTimer = (currentMedia: MediaItem<Track> | undefined) => {
        // console.log("LOG::startTimer");
        
        if(media != currentMedia) {
            resetMedia();
            media = currentMedia;
        };
        
        if(!mediaIsLogged) {
            clearInterval(logInterval);
            logInterval = setInterval( () => {
                if(state().volume >= volumeMin) {
                    timer += interval_timer;
                }
                
                if(timer >= time) {
                    stopTimer();
                    store(media);
                }
            }, interval_timer);
        }

        clearInterval(eventInterval);
        loggedEvents = [];

        eventInterval = setInterval(() => {
          const current = state();
          const duration = current.mediaDuration;
          const currentTime = current.getCurrentTime?.();

          if (!media?.id || !duration || !currentTime || duration === 0) return;

          const percent = Math.floor((currentTime / duration) * 100);

          for (const threshold of logEvents) {
              if (percent >= threshold && !loggedEvents.includes(threshold)) {
                  loggedEvents.push(threshold);
                  logEvent({
                    event_type: `play_${threshold}`,
                    entity_id: media?.id,
                    entity_type: 'track',
                    metadata: {
                        track: {...media?.meta},
                        time: time,
                        volume: current.volume
                    }
                  });
              }
          }
        }, 500);
    }

    const stopTimer = () => {
        // console.log("LOG::stopTimer");
        clearInterval(logInterval);
    }
      
    const resetMedia = () => {
        // console.log("LOG::resetMedia");
        // media = undefined;
        mediaIsLogged = false;
        timer = 0;
        loggedEvents = [];
        clearInterval(eventInterval);
    }
      
    const store = (media: MediaItem<Track> | undefined) => {
        if (media && !mediaIsLogged) {
            // console.log("LOG::store", media.id);
            mediaIsLogged = true;
            apiClient.post(`tracks/plays/${media.id}/log`, {
                queueId: media.groupId,
            });
            
            playCount++;
            localStorage.setItem('kscolta.playCount', playCount.toString());

            if (playCount === playCountToRequestFirstReview || playCount % playCountToRequestOtherReview === 0) {
              AppReviewManager.requestReview();
            }
        }
    }

    return {
        startTimer,
        stopTimer,
        resetMedia,
        store,
    };
}
